import { useCallback } from 'react';
import { useLazyFetchVisualSeoAnalysisPdfQuery } from '../service';
import downloadPdfReport from '../downloadPdfReport';

export default function useDownloadVisualSeoAnalysisPdf() {
    const [fetchVisualSeoAnalysisPdf, { isFetching }] = useLazyFetchVisualSeoAnalysisPdfQuery();

    const downloadPdf = useCallback(
        (websiteGuid: string, url: string) => downloadPdfReport(() => fetchVisualSeoAnalysisPdf({ w_guid: websiteGuid, url }).unwrap()),
        [fetchVisualSeoAnalysisPdf]
    );

    return {
        downloadPdf,
        isDownloadingPdf: isFetching,
    };
}
